export default __webpack_public_path__ + "static/media/b22.8dbf44eb.png";